import styles from "./PlaceCard.module.scss";
import Link from "next/link";
import Image from "grandus-lib/components-atomic/image/Image";
import ImageNext from "next/image";
import {isEmpty} from "lodash";
import find from "lodash/find";
const PlaceCard = ({product}) => {

  const { photo,name,shortDescription,urlTitle,parameters, gallery } = product
  const address = find(parameters, {"parameterUrlName": "adresa"});
  const placePhoto = gallery[0] ? gallery[0] : photo;

  return(
    <div className={styles.card}>
      <Link href="/produkt/[id]" as={`/produkt/${urlTitle}`}>
        <a>
          {photo ? (
            <div className={styles.image}>
              <Image photo={placePhoto} size={"140x140"} type={"jpg"} />
            </div>
          ) : (
            ""
          )}
          <div>
            {!isEmpty(name) ? (
              <h5 className={styles.name}>
                {name}
              </h5>
            ) : ""}
            {!isEmpty(shortDescription) ? (
              <p
                  className={styles.desc}
                  dangerouslySetInnerHTML={{
                __html: shortDescription
              }}/>
            ) : ""}
            {!isEmpty(address?.value) ? (
              <span className={styles.address}>
                <ImageNext src="/images/srandon/marks/blue-mark.svg" alt={"modra"} width={10} height={12} />
                {address?.value}
              </span>
            ) : ""}
          </div>
        </a>
      </Link>
    </div>
  )
}
export default PlaceCard;